import { forwardRef } from "react";
import classes from "./Textarea.module.scss";
import { clsx } from "clsx";
import { TextareaProps } from "./TextareaProps";
import { useFormControl, useErrorDescribedBy } from "@/hooks/useFormControl";
import { CheckSharp } from "@/components/ui/Icon/CheckSharp";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea(props, ref) {
    const {
      className,
      id,
      hasError,
      "aria-describedby": describedByProp,
      ...htmlProps
    } = props;

    const formControl = useFormControl();
    const describedBy = useErrorDescribedBy(describedByProp);
    const textareaId = id ?? formControl?.id;
    const textareaHasError = hasError ?? formControl?.hasError ?? false;
    const isValid = formControl?.isValid && !textareaHasError;

    return (
      <div className={clsx(classes.wrapper, className)}>
        <textarea
          ref={ref}
          id={textareaId}
          className={clsx(classes.textarea, {
            [classes.isValid]: isValid,
          })}
          {...(textareaHasError && { "aria-invalid": true })}
          {...htmlProps}
          aria-describedby={describedBy}
        />

        {isValid && (
          <div className={classes.checkWrapper}>
            <CheckSharp
              size={24}
              strokeWidth={4}
              stroke="currentColor"
              data-testid="textarea-valid-icon"
            />
          </div>
        )}
      </div>
    );
  },
);
